module.exports = "/_next/static/images/bloomberg-a90551c57ecc79733e834eda8a854334.png";